import { useTranslation } from "react-i18next";
import { LifestyleUseCasesData } from "./types";

// Helper function برای تبدیل امن به array
const ensureArray = (value: any): string[] => {
    if (Array.isArray(value)) {
        return value;
    }
    if (typeof value === "string") {
        return [value];
    }
    if (value && typeof value === "object") {
        return Object.values(value).filter((v): v is string => typeof v === "string");
    }
    return [];
};

export const useTrackerLifestyleData = (): LifestyleUseCasesData => {
    const { t } = useTranslation("trackerLifestyle");

    return {
        categories: [
            { id: "geo_security", name: t("categories.geo_security") },
            { id: "alert_profiles", name: t("categories.alert_profiles") },
            { id: "portability_track", name: t("categories.portability_track") },
        ],

        useCases: [
            /* ──────────── Geo-Security ──────────── */
            {
                image: "../../../../media/landing/LifestyleUseCases/tracker/1.webp",
                title: t("useCases.0.title"),
                description: t("useCases.0.description"),
                time: t("useCases.0.time"),
                category: "geo_security",
                color: "from-orange-400 to-red-500",
                main: true,
                tags: ensureArray(t("useCases.0.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/tracker/2.webp",
                title: t("useCases.1.title"),
                description: t("useCases.1.description"),
                time: t("useCases.1.time"),
                category: "geo_security",
                color: "from-amber-400 to-yellow-500",
                main: true,
                tags: ensureArray(t("useCases.1.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/tracker/3.webp",
                title: t("useCases.2.title"),
                description: t("useCases.2.description"),
                time: t("useCases.2.time"),
                category: "geo_security",
                color: "from-purple-400 to-fuchsia-500",
                tags: ensureArray(t("useCases.2.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/tracker/4.webp",
                title: t("useCases.3.title"),
                description: t("useCases.3.description"),
                time: t("useCases.3.time"),
                category: "geo_security",
                color: "from-amber-400 to-yellow-500",
                tags: ensureArray(t("useCases.3.tags", { returnObjects: true })),
            },

            /* ──────────── Alert Profiles ──────────── */
            {
                image: "../../../../media/landing/LifestyleUseCases/tracker/5.webp",
                title: t("useCases.4.title"),
                description: t("useCases.4.description"),
                time: t("useCases.4.time"),
                category: "alert_profiles",
                color: "from-orange-400 to-red-500",
                main: true,
                tags: ensureArray(t("useCases.4.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/tracker/6.webp",
                title: t("useCases.5.title"),
                description: t("useCases.5.description"),
                time: t("useCases.5.time"),
                category: "alert_profiles",
                color: "from-blue-400 to-indigo-500",
                tags: ensureArray(t("useCases.5.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/tracker/7.webp",
                title: t("useCases.6.title"),
                description: t("useCases.6.description"),
                time: t("useCases.6.time"),
                category: "alert_profiles",
                color: "from-purple-400 to-fuchsia-500",
                main: true,
                tags: ensureArray(t("useCases.6.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/tracker/8.webp",
                title: t("useCases.7.title"),
                description: t("useCases.7.description"),
                time: t("useCases.7.time"),
                category: "alert_profiles",
                color: "from-amber-400 to-yellow-500",
                tags: ensureArray(t("useCases.7.tags", { returnObjects: true })),
            },

            /* ──────────── Portability & Tracking ──────────── */
            {
                image: "../../../../media/landing/LifestyleUseCases/tracker/9.webp",
                title: t("useCases.8.title"),
                description: t("useCases.8.description"),
                time: t("useCases.8.time"),
                category: "portability_track",
                color: "from-orange-400 to-red-500",
                main: true,
                tags: ensureArray(t("useCases.8.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/tracker/10.webp",
                title: t("useCases.9.title"),
                description: t("useCases.9.description"),
                time: t("useCases.9.time"),
                category: "portability_track",
                color: "from-purple-400 to-fuchsia-500",
                main: true,
                tags: ensureArray(t("useCases.9.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/tracker/11.webp",
                title: t("useCases.10.title"),
                description: t("useCases.10.description"),
                time: t("useCases.10.time"),
                category: "portability_track",
                color: "from-purple-400 to-fuchsia-500",
                tags: ensureArray(t("useCases.10.tags", { returnObjects: true })),
            },
            {
                image: "../../../../media/landing/LifestyleUseCases/tracker/12.webp",
                title: t("useCases.11.title"),
                description: t("useCases.11.description"),
                time: t("useCases.11.time"),
                category: "portability_track",
                color: "from-amber-400 to-yellow-500",
                tags: ensureArray(t("useCases.11.tags", { returnObjects: true })),
            },
        ],
    };
};
